import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { AdaptivePlannerPlan } from '@/lib/api/adaptive-planner/plan';
import { adaptivePlannerQueryKeys } from '@/lib/query-keys/adaptivePlanner';

export const getPlanQueryOptions = ({ planId, enabled }: { planId: number; enabled?: boolean }) =>
  queryOptions({
    queryKey: adaptivePlannerQueryKeys.plans.detail({ planId }),
    queryFn: () => AdaptivePlannerPlan.getPlan({ planId }),
    enabled: enabled && !!planId,
  });

export const useGetPlanQuery = ({
  planId,
  enabled = true,
}: {
  planId: number;
  enabled?: boolean;
}) => {
  return useQuery(getPlanQueryOptions({ planId, enabled }));
};

export const useGetPlanSuspenseQuery = ({ planId }: { planId: number }) => {
  return useSuspenseQuery(getPlanQueryOptions({ planId, enabled: !!planId }));
};
